module.exports = __webpack_public_path__ + "static/Hero-Banner-Healthcare-61145f0ee7dc000de0d93316789db5c3.jpg";